module.exports = __webpack_public_path__ + "static/media/air-airplane-dotted-svgrepo-com.0ef66661.svg";